import React, { useEffect, useRef } from 'react';
import { useUpdateEffect } from 'ahooks';
import useProps from '../_util/useProps';
import { registerEventLayer } from '../events';
import WaterSurfaceLayer from './WaterSurfaceLayer';

export default function(props) {
    const layerRef = useRef();
    const { map, groupLayer } = useProps();

    const { show = true } = props;

    useEffect(() => {
        const layer = new WaterSurfaceLayer({...props, map});

        registerEventLayer(layer, props);

        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }

        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
